import type { Customer, TaxCategory } from "@fiscalo/shared-types";

export type InvoiceCfeType = "101" | "111" | "121";

/**
 * Default tax for a catalog line when the client is foreign (EXT / export CFE 121):
 * use export (no domestic IVA), matching new-invoice line defaults for export invoices.
 */
export function defaultCatalogTaxCategoryForClient(
  client: Pick<Customer, "documentType"> | null | undefined
): TaxCategory {
  if (client?.documentType === "EXT") {
    return "export";
  }
  return "vat_basic";
}

export function paymentMethodFromPaymentTermDays(
  days: Customer["paymentTermDays"] | undefined
): "contado" | "credito" {
  if (days === 30 || days === 60 || days === 90) return "credito";
  return "contado";
}

/**
 * For domestic CFE (101/111), use the client's saved default currency when set.
 * Export (121) always uses USD in the payload; omit so callers can rely on CFE rules.
 */
export function lineCurrencyFromClientDefault(
  client: Pick<Customer, "defaultCurrency">,
  invoiceCfeType: InvoiceCfeType
): "UYU" | "USD" | undefined {
  if (invoiceCfeType === "121") return undefined;
  const c = client.defaultCurrency;
  if (c === "USD" || c === "UYU") return c;
  return undefined;
}
